<template>
  <div class="row">
    <h1 class="text-center">Project Questions</h1>
    <router-link
      to="/add-project-question"
      class="btn-primary bg-green border-none leading-snug px-4 py-2 text-white hover:bg-green-900 inline-block no-underline rounded-full mb-2"
    >
      Add Project Question
    </router-link>
    <Table ref="myTable" :endpoint="endpoint" :tableConfig="tableConfig" />
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"
import Table from "@/components/DataTable/Table"

export default {
  components: { Table },
  data() {
    return {
      endpoint: `${siteConfig.siteURL}admin/questions?search_by_type=12&fields=id,name,points,submission_cases,data,created_on,updated_on`,
      tableConfig: [
        {
          header: { textContent: "Name", sortingParam: "name" },
          path: "name",
          classList: "w-1/3",
        },
        {
          header: { textContent: "Id" },
          path: "id",
        },
        {
          header: { textContent: "Created On", sortingParam: "created_on" },
          type: "date",
          path: "created_on",
        },
        {
          header: { textContent: "Updated On", sortingParam: "updated_on" },
          type: "date",
          path: "updated_on",
        },
        {
          header: { textContent: "No. of<br/>Sub Cases" },
          path: "submission_cases",
          formatter: function getSubmissionCasesCount(submission_cases) {
            const cases = JSON.parse(submission_cases) || []
            if (cases === undefined) {
              return 0
            }
            return cases.length || 0
          },
        },
        {
          header: { textContent: "Option" },
          routePath: "/edit-project-question/:id",
          type: "action",
          actionButtonText: "Edit",
          path: "id",
        },
      ],
    }
  },
}
</script>
